var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74.213mm",
    height: "23.1mm",
    viewBox: "0 0 74.213 23.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.264 -82.501)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.26458 0 0 .38795 0 -39.634)",
    fontFamily: "sans-serif",
    fontSize: "64px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect7250)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 122.36328,
    y: 367.91992
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'DejaVu Sans Mono'",
    fontWeight: "bold"
  }, "ENTERED"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntered);
export default __webpack_public_path__ + "static/media/entered.5b7d372e122501d411e5650b6e8cd1c9.svg";
export { ForwardRef as ReactComponent };